export default function Caret (props) {

    return (
        <svg stroke={props.stroke} className={props.className} style={props.style}  xmlns="http://www.w3.org/2000/svg" viewBox="-1 -1 6 10">
            <path d="M 0 0 L 4 4 L 0 8"/>
        </svg>
    )

}